import router from "./index";
import store from "../store";
// cookie
import { getAccessToken } from "@u/cookies";
// 全局前置守卫
router.beforeEach((to, from, next) => {
    if (!getAccessToken()) {
        if (to.name == "Protocol" || to.path.slice(1, 8) == 'support' || to.path.includes('/sys')) {
            next();
        } else if (to.name !== "Login") {
            next("Login");
        } else {
            next();
        }
    } else {
        next();
        let { meta, path, query } = to;
        store.commit('app/SET_CURRENTMENU', { meta, path, query });
    }
})
// 全局后置守卫
router.afterEach((to, from) => {
})



// WEBPACK FOOTER //
// ./src/router/permit.js